import React from 'react'
import styled from 'styled-components'
const Container = styled.div`
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: #04040485;
    top: 0px;
    left: 0px;
`;

export default function WidgetActiveBg({ active }) {
    //bg for widget
    if(!active) return null;
    return (
        <Container />
    )
}
